import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ArrowClockwise } from '@phosphor-icons/react';
import { WorkloadCard } from '../components/tenders/WorkloadCard';
import { WorkloadTenderTable } from '../components/tenders/WorkloadTenderTable';

import { PageSkeleton } from '../components/Skeletons';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOTALS = [
  ['open', 'Open tenders'], ['due_7d', 'Due in 7 days'], ['overdue', 'Overdue deadlines'],
  ['missing_docs', 'Missing documents'], ['emd_expiring_30d', 'EMDs expiring ≤30d'],
];

export default function TenderWorkload() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [active, setActive] = useState(null);

  const load = () => {
    setError('');
    axios.get(`${API}/tenders/analytics/workload`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e.response?.data?.detail || 'Could not load workload'));
  };
  useEffect(load, []);

  if (error) return <div className="p-8 text-rose-700" data-testid="workload-error">{error}</div>;
  if (!data) return <PageSkeleton />;

  const buckets = [...data.tes, data.unassigned];
  const selected = buckets.find((b) => (b.te_id || 'unassigned') === active);

  return (
    <div className="p-6 lg:p-10 max-w-[1500px]" data-testid="tender-workload-page">
      <style>{'@keyframes fadeUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}'}</style>
      <div className="flex items-end justify-between gap-4 mb-8">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#00a69c] font-semibold mb-1">Analytics</div>
          <h1 className="app-page-title" style={{ fontFamily: 'Outfit' }}>Tender Workload</h1>
          <p className="text-sm text-[#6D8E87] mt-2">Open tenders per Tender Executive, sorted by overdue then due-soon.</p>
        </div>
        <button onClick={load} className="inline-flex items-center gap-1.5 text-sm px-3 py-2 rounded-lg border border-[#D5E8E4] text-[#3B5A54] hover:bg-white transition-colors" data-testid="workload-refresh">
          <ArrowClockwise size={14} /> Refresh
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-8" data-testid="workload-totals">
        {TOTALS.map(([k, label]) => (
          <div key={k} className="rounded-xl bg-[#052A23] text-white px-4 py-3">
            <div className="text-2xl font-bold font-mono" data-testid={`workload-total-${k}`}>{data.totals[k]}</div>
            <div className="text-[11px] text-[#9FD9CF] uppercase tracking-wide">{label}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
        {buckets.map((b, i) => {
          const key = b.te_id || 'unassigned';
          return <WorkloadCard key={key} bucket={b} index={i} active={active === key} onToggle={() => setActive(active === key ? null : key)} />;
        })}
      </div>

      {selected && (
        <div className="medical-card overflow-hidden" style={{ animation: 'fadeUp .25s ease both' }} data-testid="workload-detail">
          <div className="px-4 py-3 border-b border-[#E2ECEA] font-semibold text-[#052A23]">{selected.name} · {selected.open} open</div>
          <WorkloadTenderTable bucket={selected} />
        </div>
      )}
    </div>
  );
}
